import { render, staticRenderFns } from "./StatsHome.vue?vue&type=template&id=2c3c92d8&"
import script from "./StatsHome.vue?vue&type=script&lang=js&"
export * from "./StatsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports